import { render, staticRenderFns } from "./GoalTransferModal.vue?vue&type=template&id=cbe595da"
import script from "./GoalTransferModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalTransferModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GoalTransferModal.vue?vue&type=style&index=0&id=cbe595da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports